import React, { useEffect, useRef } from "react";
import "./progressBar.scss";
import CheckCircle from "../../../assets/images/onboarding_icons/check_circle.svg";

const ProgressBar = (props) => {
  const { step, stepArrays, completedSteps, setStepNo } = props;
  const stepLabelMap = {
    offer_letter: "Offer Letter",
    personal_info: "Personal Information",
    employee_agreement: "Employee Agreement",
    federal_tax: "Federal Tax",
    onboarding_tasks: "Onboarding Tasks",
    direct_deposit: "Direct Deposit",
    state_tax: "State Tax",
    document_verification: "Document Verification",
    eligibility_acknowledge: "Eligibility Acknowledgement",
    doc_upload: "Document Upload",
    eligibility_i9: "Eligibility & I9 forms",
  };
  const stepRefs = useRef([]);
  useEffect(() => {
    const stepIndex = stepArrays.findIndex((item) => item === step);
    if (stepIndex !== -1) {
      setStepNo(stepIndex + 1);
      // Scroll the current step into view
      stepRefs.current[stepIndex]?.scrollIntoView({
        behavior: "smooth", // Smooth scrolling
        block: "center", // Align to center
      });
    }
  }, [step, stepArrays, setStepNo]);

  const getDisplayLabel = (key) => stepLabelMap[key] || key;
  return (
    <div className="progress-bar-container">
      <div
        className={
          stepArrays.length <= 2
            ? "progress-bar justify-content-start"
            : "progress-bar"
        }
      >
        {stepArrays.map((stepLabel, index) => (
          <div
            key={index}
            className="progress-step"
            ref={(el) => (stepRefs.current[index] = el)}
          >
            <div className="icon-label-container">
              <div
                className={`step-icon ${
                  completedSteps.includes(stepLabel) || step === stepLabel
                    ? "step-completed"
                    : "step-pending"
                }`}
              >
                {completedSteps.includes(stepLabel) ? (
                  <img src={CheckCircle} alt="Completed" />
                ) : (
                  <span>{index + 1}</span>
                )}
              </div>
              <span
                className={
                  completedSteps.includes(stepLabel) || step === stepLabel
                    ? "step-completed step-completed-label"
                    : "step-label"
                }
              >
                {getDisplayLabel(stepLabel)}
              </span>
            </div>
            {(index < stepArrays.length - 1 ||
              (stepArrays.length <= 2 && index === stepArrays.length - 1)) && (
              <div className="arrow-container">
                <svg
                  fill="none"
                  viewBox="0 0 22 80"
                  preserveAspectRatio="none"
                  className="right-arrow"
                >
                  <path
                    d="M0 -2L20 40L0 82"
                    stroke="currentColor"
                    vectorEffect="non-scaling-stroke"
                    strokeLinejoin="round"
                  ></path>
                </svg>
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default ProgressBar;
